export const NETWORK_CHANGE = 'NETWORK_CHANGE'
